var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.tornelli),function(tornello){return _c('li',{key:tornello.Row},[_vm._v(_vm._s(tornello.Descrizione))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }